import React, { useMemo } from 'react';
import { BsAt } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Icon, IconButton } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { showModal } from '../../../../../../../../../redux/modules/modal';
import { useCompanyActiveUsers } from '../../../../../../../../../services/company-service';

import ActivityLogTagCommentModal from './ActivityLogTagCommentModal';

const ActivityLogAtButton = ({ companyId }) => {
  const dispatch = useDispatch();
  const { data, isLoading } = useCompanyActiveUsers(companyId);

  const userChecklist = useMemo(() => {
    if (isLoading) {
      return [];
    }

    return data.map(user => ({
      id: user.userId,
      checked: false,
      description: `${user.userFirstName} ${user.userLastName}`,
      userEmail: user.userEmail
    }));
  }, [data]);

  return (
    <IconButton
      aria-label="Tag User Icon Button"
      icon={<Icon as={BsAt} boxSize={6} />}
      variant="textPrimary"
      onClick={() => dispatch(showModal(
        ActivityLogTagCommentModal,
        {
          title: 'Tag Users to Comment',
          size: 'md'
        },
        { userChecklist }
      ))}
    />
  );
};

ActivityLogAtButton.propTypes = { companyId: PropTypes.number.isRequired };

export default ActivityLogAtButton;
